import { createSelector } from '@ngrx/store'
import { selectEmployeeSalary, selectRevisedSalary } from './employee-salary.reducers'
import { EmployeeSalary } from './employee-salary.state'

export const selectStatutoryCompliances = createSelector(
  selectEmployeeSalary,
  (employeeSalary: EmployeeSalary) => employeeSalary.statutoryCompliances
)

export const selectCtcValue = createSelector(
  selectEmployeeSalary,
  (employeeSalary: EmployeeSalary) => employeeSalary.ctcValue
)

export const selectCtc = createSelector(
  selectEmployeeSalary,
  (employeeSalary: EmployeeSalary) => employeeSalary.ctc
)

export const selectOtherComponents = createSelector(
  selectEmployeeSalary,
  (employeeSalary: EmployeeSalary) => employeeSalary.salaryData.otherComponents
)

export const selectSalaryData = createSelector(
  selectEmployeeSalary,
  (employeeSalary: EmployeeSalary) => employeeSalary.salaryData
)

// --- Revision Workflow Selectors ---
export const selectRevisedStatutoryCompliances = createSelector(
  selectRevisedSalary,
  (revisedSalary: EmployeeSalary) => revisedSalary.statutoryCompliances
)

export const selectRevisedCtc = createSelector(
  selectRevisedSalary,
  (revisedSalary: EmployeeSalary) => revisedSalary.ctc
)

export const selectRevisedCtcValue = createSelector(
  selectRevisedSalary,
  (revisedSalary: EmployeeSalary) => revisedSalary.ctcValue
)

export const selectRevisedOtherComponents = createSelector(
  selectRevisedSalary,
  (revisedSalary: EmployeeSalary) => revisedSalary.salaryData.otherComponents
)

export const selectRevisedSalaryData = createSelector(
  selectRevisedSalary,
  (revisedSalary: EmployeeSalary) => revisedSalary.salaryData
)
